import type { FC } from 'react';
import styles from './label-suffix.module.css';

export const LabelSuffix: FC<{ required?: boolean; disabled?: boolean }> = ({ required, disabled }) => {
  if (disabled) {
    return null;
  }

  return (
    <>
      {required ? (
        <span aria-hidden="true" className={styles.required}>
          *
        </span>
      ) : (
        ' (optional)'
      )}
    </>
  );
};
